<template>
	<div>
		<h1>Nem megfelelő mennyiségű szilenciumot választottak</h1>
		<v-row>
			<v-col cols="12" sm="2">
				<v-menu
				    v-model="hetfovalaszto.menu"
				    :close-on-content-click="false"
				    transition="scale-transition"
				    offset-y
				    min-width="290px"
				  >
				    <template v-slot:activator="{ on, attrs }">
				      <v-text-field
				        v-model="hetfovalaszto.datum"
				        label="Hét kezdőnapja"
				        prepend-inner-icon="fa-calendar"
				        readonly
				        v-bind="attrs"
				        v-on="on"
				      ></v-text-field>
				    </template>
				    <v-date-picker
				      v-model="hetfovalaszto.datum"
				      no-title
				      scrollable
						  :allowed-dates="hetfok"
							first-day-of-week="1"
							@input="hetfovalaszto.menu=false, tablazatfrissitese()"
				    >
				    </v-date-picker>
			  </v-menu>
			</v-col>
		</v-row>
		<v-data-table
			:items="nemelegszilenciumotvalasztottak"
			:headers="fejlecek"
			sort-by="nev"
		/>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>

</template>

<script>
	export default {
		data: function(){
			return {
				tablazatmutat: false,
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				hetfovalaszto: {
					menu: false,
					datum: this.aktualishetfo()
				},

				nemelegszilenciumotvalasztottak: [],
				fejlecek: [
					{
						text: 'Név',
						value: 'nev',
						align: 'center',
						filterable: false,
						sortable: true,
						groupable: false
					},
					{
						text: 'Csoport',
						value: 'csoportnev',
						align: 'center',
						filterable: false,
						sortable: true,
						groupable: true
					},
					{
						text: 'Csoportvezető',
						value: 'csopveznev',
						align: 'center',
						filterable: false,
						sortable: false,
						groupable: false
					},
					{
						text: 'Napi bontás',
						value: 'napibontas',
						align: 'center',
						filterable: false,
						sortable: false,
						groupable: false
					}
				]

			}
		},
		watch: {

		},
		methods: {
			tablazatfrissitese: function() {
        this.axios.get(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/nemelegszilenciumotvalasztottak/"+this.hetfovalaszto.datum)
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
						this.nemelegszilenciumotvalasztottak = response.data.adatok.nemelegszilenciumotvalasztottak
						var napibontas = response.data.adatok.napibontas
						this.nemelegszilenciumotvalasztottak = this.nemelegszilenciumotvalasztottak.map((neszv) => {

							return {
								...neszv,
								napibontas: napibontas[neszv.id].map(n => {
									switch (n) {
										case 0:
											return "hétfő";
										case 1: 
											return "kedd";
										case 2:
											return "szerda"
										case 3:
											return "csütörtök"
									}
								}).join(", ")
							}
						})
					}
                  })
			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
		},
		mounted(){
			this.tablazatfrissitese()
		}
	}
</script>
